<div class="min-h-screen px-6 sm:px-8 py-8 bg-gray-50 font-Arimo">
  <!-- Header -->
  <h1 class="text-xl sm:text-2xl font-bold text-gray-800 mb-2">{{ 'INVOICE.TITLE' | translate }}</h1>
  <p class="text-gray-600 text-sm sm:text-base mb-6">
    {{ 'INVOICE.DESCRIPTION' | translate }}
  </p>

  <!-- Loader -->
  <app-loader [show]="loading" [mainMessage]="'INVOICE.LOADING_MESSAGE' | translate"
    [subMessage]="'INVOICE.LOADING_SUB_MESSAGE' | translate">
  </app-loader>

  <!-- Error Message -->
  <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
    <p>{{ error }}</p>
  </div>

  <!-- Invoice List -->
  <div *ngIf="!loading && !error" class="space-y-6">
    <div *ngFor="let policy of policies" class="bg-white rounded-xl shadow-md border border-gray-200 p-6">
      <!-- Header Row -->
      <div class="flex justify-between items-start mb-4">
        <div>
          <div class="flex gap-2 items-center mb-2">
            <div class="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold" [ngClass]="
                getProviderColor(policy.quoteResponse?.providerName || '')
              ">
              {{
              getProviderInitials(policy.quoteResponse?.providerName || "")
              }}
            </div>
            <h3 class="text-base sm:text-lg font-bold text-gray-900">
              {{ policy.quoteResponse?.providerName }}
            </h3>
          </div>
          <p class="text-sm text-gray-500">
            {{ policy.providerName }}
          </p>
          <p class="text-sm text-gray-500 mt-1">
            {{ policy.startDate | date : "MMM d, y" }} -
            {{ policy.endDate | date : "MMM d, y" }}
          </p>
        </div>

        <span class="px-3 py-1 text-xs font-semibold rounded-full capitalize" [ngClass]="{
            'bg-green-100 text-green-700':
              policy.status.toLowerCase() === 'active',
            'bg-yellow-100 text-yellow-700':
              policy.status.toLowerCase() === 'pending',
            'bg-red-100 text-red-700':
              policy.status.toLowerCase() === 'cancelled',
            'bg-orange-100 text-orange-700':
              policy.status.toLowerCase() === 'expired'
          }">
          {{ policy.status.toLowerCase() }}
        </span>
      </div>

      <!-- Premium Amount -->
      <div class="mb-4">
        <p class="text-xs text-gray-500">{{ 'INVOICE.PREMIUM_AMOUNT' | translate }}</p>
        <p class="text-lg sm:text-xl font-bold text-gray-900">
          {{ policy.currency }}{{ policy.totalPremium | number : "1.2-2" }}
        </p>
      </div>

      <!-- Invoice Number & Button -->
      <div class="flex flex-col gap-2">
        <div class="w-full sm:w-auto">
          <p class="text-xs text-gray-500 mb-1">{{ 'INVOICE.INVOICE_NUMBER' | translate }}</p>
          <input type="text" disabled
            class="w-full sm:w-60 px-3 py-1.5 border border-gray-300 rounded-md text-sm bg-gray-100"
            value="{{ policy.invoice?.number }}" />
        </div>
        <div class="flex justify-end gap-2">
          <button (click)="downloadPayerInvoicePdf(policy.policyNumber)" [disabled]="isDownloading"
            class="px-4 py-2 bg-[#009689] text-white rounded-md text-sm font-medium hover:bg-[#00BBA7] focus:outline-none focus:ring-2 focus:ring-emerald-500 transition-colors w-full sm:w-auto  disabled:cursor-not-allowed disabled:opacity-60">
            {{ 'INVOICE.DOWNLOAD_PAYER_INVOICE' | translate }}
          </button>
          <button (click)="downloadInvoicePdf(policy.policyNumber)" [disabled]="isDownloading"
            class="px-4 py-2 bg-[#009689] text-white rounded-md text-sm font-medium hover:bg-[#00BBA7] focus:outline-none focus:ring-2 focus:ring-emerald-500 transition-colors w-full sm:w-auto  disabled:cursor-not-allowed disabled:opacity-60">
            {{ 'INVOICE.DOWNLOAD_INVOICE' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="policies.length === 0" class="bg-white rounded-xl border border-gray-200 p-6 md:p-8 text-center">
      <div class="mx-auto flex items-center justify-center h-12 w-12 md:h-16 md:w-16 rounded-full bg-blue-50 mb-4">
        <svg class="h-6 w-6 md:h-8 md:w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h3 class="text-lg md:text-xl font-semibold text-gray-900 mb-2">
        {{ 'INVOICE.NO_INVOICES_TITLE' | translate }}
      </h3>
    </div>
  </div>
</div>
<div id="invoicePdf" class="hidden"></div>